import React, { useEffect, useReducer } from 'react';
import { LoadScript } from '@react-google-maps/api';
import { Config } from '../../../../types';
import { Loader } from '@strapi/design-system';

const libraries: 'places'[] = ['places'];

interface GoogleMapsProviderProps {
    config?: Config;
    children: React.ReactNode;
}

export default function GoogleMapsProvider({ name, config, children }: GoogleMapsProviderProps) {
    const [scriptLoaded, onScriptLoaded] = useReducer(() => true, false);

    if (!config) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Loader small />
            </div>
        );
    }

    return (
        <>
            <LoadScript
                id={name}
                googleMapsApiKey={config.googleMapsKey}
                libraries={libraries}
                onLoad={onScriptLoaded}
            />
            {scriptLoaded ? children : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Loader small />
                </div>
            )}
        </>
    );
} 